import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a3bf784"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-tips" }, " 链接已生成，可在外部浏览器打开并下载文件，按照格式打印填写和盖章后拍摄图片并上传！ ", -1))
const _hoisted_3 = ["src"]

import { Button, ImagePreview } from 'vant'
import { withDefaults, computed } from 'vue'
import appHost from '@/utils/app'
import PopupCommonWrap from '@/components/popup/common-wrap.vue'
import CommonFooterWrap from '@/components/CommonFooterWrap.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'jijia-application-example',
  props: {
    show: { type: Boolean, default: false },
    mode: { default: 'surrender' }
  },
  emits: ['update:show'],
  setup(__props: any, { emit: emits }) {

const props = __props as { show: boolean, mode: string };

const surrenderMode = 'surrender'


const imageChangeUrl =
  'https://static.knowledge.xag.cn/img/jijia2023/insurance-application-example.png'
const imageSurrenderUrl =
  'https://static.knowledge.xag.cn/img/jijia2023/insurance-surrender-example.png'

const popupStyle = {
  backgroundColor: 'white',
}
const changeDownloadUrl =
  'https://static.knowledge.xag.cn/doc/jijia-2023/template-for-change-application-form.docx'
const surrenderDownloadUrl =
  'https://static.knowledge.xag.cn/doc/jijia-2023/template-for-surrender-insurance-form.docx'
const isSurrender = computed(() => {
  return props.mode === surrenderMode
})
const useImage = computed(() => {
  return isSurrender.value ? imageSurrenderUrl : imageChangeUrl
})
const downloadUrl = computed(() => {
  return isSurrender.value ? surrenderDownloadUrl : changeDownloadUrl
})
function updateShowHandle(value: boolean) {
  emits('update:show', value)
}

function openFile() {
  appHost.openBrowser(downloadUrl.value)
}
function previewHandle() {
  ImagePreview([useImage.value])
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupCommonWrap, {
    style: popupStyle,
    show: props.show,
    title: "申请书示例",
    teleport: "body",
    "onUpdate:show": updateShowHandle
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("img", {
          src: _unref(useImage),
          class: "",
          onClick: previewHandle,
          alt: ""
        }, null, 8, _hoisted_3),
        _createVNode(CommonFooterWrap, null, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              plain: "",
              type: "success",
              class: "donwload-btn",
              onClick: openFile
            }, {
              default: _withCtx(() => [
                _createTextVNode("下载模板")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})